import { render, staticRenderFns } from "./GenercProperties.vue?vue&type=template&id=342eab46&scoped=true"
import script from "./GenercProperties.vue?vue&type=script&lang=js"
export * from "./GenercProperties.vue?vue&type=script&lang=js"
import style0 from "./GenercProperties.vue?vue&type=style&index=0&id=342eab46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342eab46",
  null
  
)

export default component.exports